export default __webpack_public_path__ + "static/media/goshen70.337caf5a.jpg";